// list of routes permitted for redirection, e.g. using backTo attribute

import {
  IS_ENROLL,
  IS_SHORT_TERM,
  IS_FIXED_BENEFIT_MEDICAL,
  IS_BRIDGE_TO_MEDICARE,
  IS_DENTAL_AND_VISION
} from 'core/constants/environment'

import {
  COMPARE_PLANS,
  DETAILS,
  QUOTES,
  APPLICATION,
  START_APPLICATION,
  ADD_ONS,
  ELIGIBILITY
} from 'sites/routes.ts'

function getPermittedRoutes(products) {
  if (products.IS_ENROLL) {
    return {
      _default: QUOTES,
      DETAILS,
      QUOTES,
      APPLICATION,
      START_APPLICATION,
      ADD_ONS,
      ELIGIBILITY
    }
  }

  if (products.IS_SHORT_TERM) {
    return {
      _default: QUOTES,
      DETAILS,
      QUOTES,
      APPLICATION,
      START_APPLICATION,
      COMPARE_PLANS,
      ELIGIBILITY
    }
  }

  if (products.IS_FIXED_BENEFIT_MEDICAL) {
    return {
      _default: QUOTES,
      DETAILS,
      QUOTES,
      APPLICATION,
      ELIGIBILITY
    }
  }

  if (products.IS_BRIDGE_TO_MEDICARE) {
    return {
      _default: QUOTES,
      DETAILS,
      QUOTES,
      APPLICATION,
      START_APPLICATION,
      ELIGIBILITY
    }
  }

  if (products.IS_DENTAL_AND_VISION) {
    return {
      _default: QUOTES,
      QUOTES,
      APPLICATION,
      START_APPLICATION
    }
  }

  return { _default: '/' }
}

export default getPermittedRoutes({
  IS_ENROLL,
  IS_SHORT_TERM,
  IS_FIXED_BENEFIT_MEDICAL,
  IS_BRIDGE_TO_MEDICARE,
  IS_DENTAL_AND_VISION
})
